import { render, staticRenderFns } from "./CFileManager.vue?vue&type=template&id=b0fdbc64&scoped=true&"
import script from "./CFileManager.vue?vue&type=script&lang=ts&"
export * from "./CFileManager.vue?vue&type=script&lang=ts&"
import style0 from "./CFileManager.vue?vue&type=style&index=0&id=b0fdbc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fdbc64",
  null
  
)

export default component.exports